import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AppHeader from '../components/ui/AppHeader';
import Contractor1099Header from '../components/pm/Contractor1099Header';
import { useAuth } from '../utils/AuthContext';
import { isInternal1099ContractorUser } from '../utils/userRoles';
import {
  canAccessPeopleBenefitsOrTravel,
  canAccessPeopleHiring,
  canAccessPeopleHubNav,
  canAccessPeopleTeam,
  isFieldStaffPeopleNavRole,
} from '../utils/employeeBenefitsAccess';
import '../components/pm/pm-shared.css';
import './OperationsHub.css';
import './PeopleHubPage.css';

const PeopleHubLayout: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();
  const designations = user?.designations;

  if (!user) return <Navigate to="/login" replace />;

  const isInternal1099 = isInternal1099ContractorUser({
    role: user.role,
    is1099Contractor: user.is1099Contractor,
  });

  if (!canAccessPeopleHubNav(user.role, designations) && !isInternal1099) {
    return <Navigate to="/" replace />;
  }

  if (
    isInternal1099
    && !location.pathname.startsWith('/people/handbook')
  ) {
    return <Navigate to="/people/handbook" replace />;
  }

  const hasFullPeopleHub = canAccessPeopleBenefitsOrTravel(user.role, designations);
  const staffLimitedPeopleHub =
    isFieldStaffPeopleNavRole(user.role) && !hasFullPeopleHub && !isInternal1099;
  const blockedStaffPath =
    staffLimitedPeopleHub
    && (location.pathname.startsWith('/people/benefits')
      || location.pathname.startsWith('/people/travel')
      || location.pathname.startsWith('/people/hiring'));

  if (blockedStaffPath || (!canAccessPeopleHiring(user.role, designations) && location.pathname.startsWith('/people/hiring'))) {
    return <Navigate to="/people" replace />;
  }

  if (location.pathname.startsWith('/people/team') && !canAccessPeopleTeam(user.role)) {
    return <Navigate to="/people" replace />;
  }

  const Header = isInternal1099 ? Contractor1099Header : AppHeader;

  return (
    <div className="ops-hub">
      <Header />
      <div className="ops-hub-layout people-hub-layout">
        <div className="ops-hub-main people-hub-main people-hub-main-with-subnav">
          <div className="people-hub-outlet-wrap">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeopleHubLayout;
